import { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const SUPPORTED_LANGUAGES: {
  languageRegionCode: LanguageRegionCode;
  country: string;
  translatedLanguageName: string;
}[] = [
  {
    languageRegionCode: 'en-US',
    country: 'United States',
    translatedLanguageName: 'English (US)'
  },
  {
    languageRegionCode: 'en-GB',
    country: 'United Kingdom',
    translatedLanguageName: 'English (UK)'
  },
  {
    languageRegionCode: 'da-DK',
    country: 'Denmark',
    translatedLanguageName: 'Dansk (Danmark)'
  },
  {
    languageRegionCode: 'de-DE',
    country: 'Germany',
    translatedLanguageName: 'Deutsch (Deutschland)'
  },
  {
    languageRegionCode: 'es-ES',
    country: 'Spain',
    translatedLanguageName: 'Español (España)'
  },
  {
    languageRegionCode: 'es-MX',
    country: 'Latin America',
    translatedLanguageName: 'Español (Latinoamérica)'
  },
  {
    languageRegionCode: 'fr-FR',
    country: 'France',
    translatedLanguageName: 'Français (France)'
  },
  {
    languageRegionCode: 'it-IT',
    country: 'Italy',
    translatedLanguageName: 'Italiano (Italia)'
  },
  {
    languageRegionCode: 'nl-NL',
    country: 'The Netherlands',
    translatedLanguageName: 'Nederlands (Nederland)'
  },
  {
    languageRegionCode: 'nb-NO',
    country: 'Norway',
    translatedLanguageName: 'Norsk bokmål (Norge)'
  },
  {
    languageRegionCode: 'pl-PL',
    country: 'Poland',
    translatedLanguageName: 'Polski (Polska)'
  },
  {
    languageRegionCode: 'pt-BR',
    country: 'Brazil',
    translatedLanguageName: 'Português (Brasil)'
  },
  {
    languageRegionCode: 'pt-PT',
    country: 'Portugal',
    translatedLanguageName: 'Português (Portugal)'
  },
  {
    languageRegionCode: 'sv-SE',
    country: 'Sweden',
    translatedLanguageName: 'Svenska (Sverige)'
  }
];

export default SUPPORTED_LANGUAGES;
